import React from 'react';
import { withRouter } from 'react-router-dom';
import { makeStyles, CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
	progressContainer: {
		display: 'flex',
		justifyContent: 'center',
	},
	progress: {
		color: theme.palette.pink
	},
}));

const Progress = (props) => {
	const classes = useStyles();
	const { status, ...other } = props;

	return (
		status ?
			<div className={classes.progressContainer}>
				<CircularProgress className={classes.progress} {...other} />
			</div>
			:
			<></>
	);
};

Progress.propTypes = {
	status: PropTypes.bool,
};

export default withRouter(Progress);
